import React, { useCallback } from 'react'
import { Card, Avatar, Button, Image, Table } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getUserDetailAPI, getUserSearchListAPI, getUserHouseViewListAPI, getUserRoomTypeViewListAPI, getUserRoomViewListAPI, getUserIntentionHouseListAPI } from '@/apis/user'
const { Column } = Table
import Dayjs from 'dayjs'
import styles from './userInfo.module.scss'

export default function UserInfo({ changeLinkTabs }) {
  const location = useParams()
  const userId = location.userid
  const [userInfo, setUserInfo] = useState({}) //  用户信息
  const [intentionList, setIntentionList] = useState([]) //  意向楼盘列表
  const [searchList, setSearchList] = useState([]) //  搜索记录
  const [roomTypeListLoading, setRoomTypeListLoading] = useState(false) //  户型表格加载状态
  const [roomTypeList, setRoomTypeList] = useState([]) //  户型访问记录
  const [roomListLoading, setRoomListLoading] = useState(false) //  房源表格加载状态
  const [roomList, setRoomList] = useState([]) //  房源访问记录
  const [houseTotal, setHouseTotal] = useState(0) //  楼盘总数
  const [priceList, setPriceList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [plateList, setPlateList] = useState([])

  //  用户信息
  const getDetail = async () => {
    const res = await getUserDetailAPI({ userId })
    if (res.success === true) {
      if (res.result) {
        res.result.nickName = res.result.nickName ? decodeURIComponent(res.result.nickName) : '暂无昵称' + res.result.userId.toString().slice(-4)
        res.result.addressTime = Dayjs(res.result.addressTime).format('YYYY-MM-DD')
      }
      setUserInfo(res.result)
    }
  }
  //  意向列表
  const getUserIntentionHouseList = async () => {
    const res = await getUserIntentionHouseListAPI({ userId, pageInt: 1, pageSize: 10 })
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach(item => {
          item.intentionRate = Math.round(item.intentionRate * 1000) / 10
        })
        setIntentionList(res.result.list)
      }
    }
  }
  //  搜索列表
  const getUserSearchList = async () => {
    const res = await getUserSearchListAPI({ userId, days: 30, pageInt: 1, pageSize: 10 })
    if (res.success === true) {
      if (res.result.list) {
        setSearchList(res.result.list)
      }
    }
  }
  //  楼盘列表
  const getUserHouseViewList = async () => {
    let priceList = [
      {
        name: '0.8万以下',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '0.8-1万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '1-1.5万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '1.5-2万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '2-2.5万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '2.5-3万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '3-4万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '4万以上',
        value: 0,
        rate: '' // 占比
      }
    ]
    let districtList = []
    let districtIds = []
    let plateList = []
    let plateIds = []
    const res = await getUserHouseViewListAPI({ userId, days: 30, pageInt: 1, pageSize: 1000 })
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach(item => {
          if (item.price >= 40000) {
            priceList[7].value++
            priceList[7].rate = ((priceList[7].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 30000) {
            priceList[6].value++
            priceList[6].rate = ((priceList[6].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 25000) {
            priceList[5].value++
            priceList[5].rate = ((priceList[5].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 20000) {
            priceList[4].value++
            priceList[4].rate = ((priceList[4].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 15000) {
            priceList[3].value++
            priceList[3].rate = ((priceList[3].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 10000) {
            priceList[2].value++
            priceList[2].rate = ((priceList[2].value / res.result.total) * 100).toFixed(0) + '%'
          } else if (item.price >= 8000) {
            priceList[1].value++
            priceList[1].rate = ((priceList[1].value / res.result.total) * 100).toFixed(0) + '%'
          } else {
            priceList[0].value++
            priceList[0].rate = ((priceList[0].value / res.result.total) * 100).toFixed(0) + '%'
          }
          let districtIndex = districtIds.indexOf(item.districtId)
          if (districtIndex < 0) {
            districtIds.push(item.districtId)
            districtList.push({
              id: item.districtId,
              name: item.districtName,
              value: 1,
              rate: ((1 / res.result.total) * 100).toFixed(0) + '%'
            })
          } else {
            districtList[districtIndex].value++
            districtList[districtIndex].rate = ((districtList[districtIndex].value / res.result.total) * 100).toFixed(0) + '%'
          }
          let plateIndex = plateIds.indexOf(item.plateId)
          if (plateIndex < 0) {
            plateIds.push(item.plateId)
            plateList.push({
              id: item.plateId,
              name: item.plateName,
              value: 1,
              rate: ((1 / res.result.total) * 100).toFixed(0) + '%'
            })
          } else {
            plateList[plateIndex].value++
            plateList[plateIndex].rate = ((plateList[plateIndex].value / res.result.total) * 100).toFixed(0) + '%'
          }
        })
        priceList.sort((a, b) => {
          return b.value - a.value
        })
        priceList = priceList.slice(0, 3)
        districtList.sort((a, b) => {
          return b.value - a.value
        })
        districtList = districtList.slice(0, 3)
        plateList.sort((a, b) => {
          return b.value - a.value
        })
        plateList = plateList.slice(0, 3)
        setPriceList(priceList)
        setDistrictList(districtList)
        setPlateList(plateList)
      }
      setHouseTotal(res.result.total)
    }
  }
  //  户型列表
  const getUserRoomTypeViewList = async () => {
    setRoomTypeListLoading(true)
    const res = await getUserRoomTypeViewListAPI({ userId, days: 30, pageInt: 1, pageSize: 10 })
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
        })
        setRoomTypeList(res.result.list)
      }
      setRoomTypeListLoading(false)
    }
  }
  //  房源列表
  const getUserRoomViewList = async () => {
    setRoomListLoading(true)
    const res = await getUserRoomViewListAPI({ userId, days: 30, pageInt: 1, pageSize: 10 })
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.saleStatus2 = item.saleStatus == 1 ? '已售' : item.saleStatus == 2 ? '未售' : ''
          item.unitName = item.unitName == '/' ? '' : item.unitName + '单元'
          item.key = index
        })
        setRoomList(res.result.list)
      }
      setRoomListLoading(false)
    }
  }
  useEffect(() => {
    getDetail()
    getUserIntentionHouseList()
    getUserSearchList()
    getUserHouseViewList()
    getUserRoomTypeViewList()
    getUserRoomViewList()
  }, [])

  return (
    <div>
      <Card className="card" title="基础信息">
        <div className={styles['info-item']}>
          <div className={styles['info-item-left']}>头像昵称</div>
          <div className={styles['info-item-right']}>
            <Avatar shape="square" size={24} draggable={false} src={userInfo.avatarUrl ? userInfo.avatarUrl+ '?x-oss-process=image/resize,w_24,m_lfit' : '/images/avatar.png'} />
            <div className={styles['info-name']}>{userInfo.nickName}</div>
          </div>
        </div>
        <div className={styles['info-item-address']}>
          <div className={styles['info-item-flex']}>
            <div className={styles['info-item-left']}>最新授权位置</div>
            <div className={styles['info-item-right']}>
              <div>
                {userInfo.address} 附近（{userInfo.addressTime}）
              </div>
            </div>
          </div>
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/addresslist/' + userInfo.userId)
            })}
          >
            更多位置
          </Button>
        </div>
        <div className={styles['info-item']}>
          <div className={styles['info-item-left']}>广域标签</div>
          <div className={styles['info-item-right']}>
            {userInfo.labelList && userInfo.labelList.map((item, index) => {
              return (
                <div className={styles['label-item']} key={index}>{item.tagName}</div>
              )
            })}
          </div>
        </div>
      </Card>
      <Card className="card" title={
        <div className={['flex', 'align-items'].join(' ')}>
          <div>意向楼盘</div>
          <div className={['margin-left-16', 'font-normal', 'color-999999'].join(' ')}>基于近90天数据</div>
        </div>
      }>
        <div className={['line-height-24', 'font-size16', 'ellipsis'].join(' ')}>
          {intentionList.map((item, index) => {
            return (
              <span key={index}>{item.houseName}({item.intentionRate}%){index == intentionList.length - 1 ? '' : '、'}</span>
            )
          })}
        </div>
      </Card>
      <Card
        className="card"
        title="搜索偏好"
        extra={
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/searchlog/' + userInfo.userId)
            })}
          >
            更多数据
          </Button>
        }
      >
        <div className={styles['address-list']}>
          {searchList.map((item, index) => {
            return (
              <div key={index}>
                {item.keyWords}
                {index == searchList.length - 1 ? '' : '、'}
              </div>
            )
          })}
        </div>
      </Card>
      <Card
        className="card"
        title="楼盘偏好"
        extra={
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/houselist/' + userInfo.userId)
            })}
          >
            更多数据
          </Button>
        }
      >
        <div className={styles['house-count']}>
          <div>
            <span className="red">30天</span>，该用户共访问楼盘<span className="green">{houseTotal}</span>个，以下是访问偏好分布（仅供参考）：
          </div>
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/houselist/' + userInfo.userId)
            })}
          >
            更多详情
          </Button>
        </div>
        <div className="flex-between" style={{ marginTop: '24px' }}>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>单价偏好（参考价）</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {priceList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {priceList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }}></div>
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>区域偏好</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {districtList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {districtList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }}></div>
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>板块偏好</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {plateList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {plateList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }}></div>
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Card
        className="card"
        title="户型偏好"
        extra={
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/roomtypelist/' + userInfo.userId)
            })}
          >
            更多数据
          </Button>
        }
      >
        <Table dataSource={roomTypeList} loading={roomTypeListLoading} pagination={false}>
          <Column title="户型图" dataIndex="img" key="action" render={(_, record) => <Image width={80} src={record.img + '?x-oss-process=image/resize,w_80,m_lfit'} preview={{ src: record.img }} />} />
          <Column title="户型名称" dataIndex="name" />
          <Column title="房型" dataIndex="roomLayout" />
          <Column title="面积" dataIndex="area" />
          <Column title="所属楼盘" dataIndex="houseName" />
          <Column title="7天有效访问" dataIndex="weekVisitorNum" />
          <Column title="30天" dataIndex="monthVisitorNum" />
          <Column title="90天" dataIndex="quarterVisitorNum" />
        </Table>
      </Card>
      <Card
        className="card"
        title="房源偏好"
        extra={
          <Button
            type="link"
            className="color-576b95"
            onClick={useCallback(() => {
              changeLinkTabs('/managecenter/user/roomlist/' + userInfo.userId)
            })}
          >
            更多数据
          </Button>
        }
      >
        <Table dataSource={roomList} loading={roomListLoading} pagination={false} rowKey="key">
          <Column title="所属楼盘" dataIndex="houseName" />
          <Column title="预售证" dataIndex="evidenceName" />
          <Column title="楼栋" dataIndex="shortName" />
          <Column title="单元" dataIndex="unitName" />
          <Column title="楼层" dataIndex="floor" />
          <Column title="房号" dataIndex="name" />
          <Column title="面积" dataIndex="area" />
          <Column title="单价" dataIndex="price" />
          <Column title="总价" dataIndex="totalPrice" />
          <Column title="交付标准" dataIndex="delivery" />
          <Column title="状态" dataIndex="saleStatus2" />
          <Column title="有效访问次数" dataIndex="quarterVisitorNum" />
        </Table>
      </Card>
    </div>
  )
}
